import { render, staticRenderFns } from "./SessionActivities.vue?vue&type=template&id=7915416f&scoped=true"
import script from "./SessionActivities.vue?vue&type=script&lang=js"
export * from "./SessionActivities.vue?vue&type=script&lang=js"
import style0 from "./SessionActivities.vue?vue&type=style&index=0&id=7915416f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915416f",
  null
  
)

export default component.exports